import React from "react";
import { Link } from "react-router-dom";
import { Mail, Globe, Linkedin, Instagram } from "lucide-react";

const REGIONS = ["Australia", "New Zealand", "Canada", "United Kingdom", "USA"];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="main-footer">
      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-7 flex justify-center md:justify-start">
          <img src="/logo-full.png" alt="Teaching Pathways — Learn · Mentor · Grow"
            width="1200" height="429" className="h-14 sm:h-16 w-auto object-contain" data-testid="footer-logo" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <p className="text-sm text-slate-400 leading-relaxed">Supporting Future Teachers. Strengthening Partnerships. Building Careers.</p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-teal-600 flex items-center justify-center transition-colors" data-testid="footer-linkedin"><Linkedin className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-teal-600 flex items-center justify-center transition-colors" data-testid="footer-instagram"><Instagram className="w-4 h-4" /></a>
              <a href="mailto:admin@teachingpathways.com.au" className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-teal-600 flex items-center justify-center transition-colors" data-testid="footer-email"><Mail className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4 text-sm">Programs</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/future-teachers" className="hover:text-teal-400 transition-colors">Future Teachers</Link></li>
              <li><Link to="/international-teachers" className="hover:text-teal-400 transition-colors">International Teachers</Link></li>
              <li><Link to="/career-support" className="hover:text-teal-400 transition-colors">Career Support</Link></li>
              <li><Link to="/mentors-schools" className="hover:text-teal-400 transition-colors">Mentors & Schools</Link></li>
              <li><Link to="/universities" className="hover:text-teal-400 transition-colors">Universities</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4 text-sm">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/tutoring" className="hover:text-teal-400 transition-colors">Tutoring Marketplace</Link></li>
              <li><Link to="/resources" className="hover:text-teal-400 transition-colors">Resource Store</Link></li>
              <li><Link to="/workshop-series" className="hover:text-teal-400 transition-colors">Workshop Slide Deck Series</Link></li>
              <li><Link to="/ai-workshops" className="hover:text-teal-400 transition-colors">AI Workshops</Link></li>
              <li><Link to="/blog" className="hover:text-teal-400 transition-colors">Blog</Link></li>
              <li><Link to="/about" className="hover:text-teal-400 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-teal-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4 text-sm flex items-center gap-2"><Globe className="w-4 h-4" /> Global Pathways</h4>
            <ul className="space-y-2.5 text-sm">
              {REGIONS.map((r) => (
                <li key={r} className="flex items-center gap-2 text-slate-400">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" /> Teaching Pathways {r}
                  {r !== "Australia" && <span className="text-[10px] uppercase tracking-wide text-slate-600">soon</span>}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} Teaching Pathways. All rights reserved.</p>
          <p>Built for educators, worldwide.</p>
        </div>
      </div>
    </footer>
  );
}
